import { render, staticRenderFns } from "./CompletarDatos.vue?vue&type=template&id=0164eb70&"
import script from "./CompletarDatos.vue?vue&type=script&lang=js&"
export * from "./CompletarDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports